import { render, staticRenderFns } from "./look.vue?vue&type=template&id=9948cff8&scoped=true"
import script from "./look.vue?vue&type=script&lang=js"
export * from "./look.vue?vue&type=script&lang=js"
import style0 from "./look.vue?vue&type=style&index=0&id=9948cff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9948cff8",
  null
  
)

export default component.exports